import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  private baseUrl = 'https://xxx/api-dashboard/api-files/';

  constructor(private http: HttpClient) { }

  uploadFile(clientId: string, folder: string, file: File): Observable<any> {
      const formData = new FormData();
      formData.append('clientId', clientId);
      formData.append('folder', folder);
      formData.append('file', file);
      return this.http.post(`${this.baseUrl}/upload.php`, formData);
  }
}
